export default __webpack_public_path__ + "static/media/dole-juice-bg@3x.5d7ed3be.png";